import EnrichmentClient from './EnrichmentClient';
import HttpMethod from '../../constant/HttpMethod';
import { EnrichmentMethods } from '../../constant/MethodNames';
import HttpClient from '../../gateway/HttpClient';
import { query } from '@trlogic/client-js';
import { EnrichmentBase } from '../../domain/enrichment/EnrichmentDomain';
import { notBlank, notUndefined } from '../../util/Assert';
import ComponentName from '../../constant/ComponentName';
import { ActionType } from '../../constant/Constants';
import Query = query.Query;

class NestEnrichmentClient implements EnrichmentClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public save(enrichment: EnrichmentBase): Promise<void> {
    notUndefined(enrichment, 'Enrichment cannot be undefined');
    return this.httpClient.execute(HttpMethod.POST, `${EnrichmentMethods.SAVE}`, enrichment);
  }

  public remove(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.DELETE, `${EnrichmentMethods.REMOVE}/${id}`);
  }

  public deploy(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${EnrichmentMethods.DEPLOY}/${id}`);
  }

  public undeploy(id: string): Promise<void> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.POST, `${EnrichmentMethods.UNDEPLOY}/${id}`);
  }

  public exists(id: string): Promise<{ type: ComponentName; id: string }> {
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    return this.httpClient.execute(HttpMethod.GET, `${EnrichmentMethods.EXIST}/${id}`);
  }

  public count(query: Query): Promise<number> {
    notUndefined(query, 'Query cannot be undefined');
    return this.httpClient.execute(HttpMethod.POST, EnrichmentMethods.COUNT, query);
  }

  public bulkAction(ids: string[], type: ActionType): Promise<{ id: string; error: any }[]> {
    const payload = { ids, type };
    return this.httpClient.execute(HttpMethod.POST, EnrichmentMethods.BULK_ACTION, payload);
  }
}

export default NestEnrichmentClient;
